/* Copyright (c) 2020-present CloudIO Inc */

import {
  Aggregate,
  AggregateFunction,
  GenericDataRecord,
} from '@cloudio-saas/datasource-types';
import { BaseProps, Chartjs } from 'componentregistry';
import React, { lazy, Suspense } from 'react';

const ChartjsLazy = lazy(
  () => import(/* webpackChunkName: "chart" */ './ChartjsLazy'),
);

export const getChartQueryProps = (
  functionType: AggregateFunction,
  valueAttribute: string,
  labelAttribute: string,
  categoryAttribute?: string,
  orderByAttribute?: string,
  categoryKeyAttribute?: string,
) => {
  const aggregateList: Aggregate<GenericDataRecord>[] = [];
  aggregateList.push({
    aggregateFunction: functionType,
    attributeCode: valueAttribute,
    intoAttributeCode: valueAttribute,
  });
  const groupByAttributeCodeList = categoryAttribute
    ? categoryKeyAttribute
      ? [categoryKeyAttribute, categoryAttribute, labelAttribute]
      : [categoryAttribute, labelAttribute]
    : [labelAttribute];
  let orderByClause;
  if (orderByAttribute) {
    orderByClause = `#${orderByAttribute}#`;
    if (!groupByAttributeCodeList.includes(orderByAttribute)) {
      groupByAttributeCodeList.push(orderByAttribute);
    }
  }
  return { aggregateList, groupByAttributeCodeList, orderByClause };
};

export interface ChartjsProps
  extends Required<Chartjs.Chartjs>,
    BaseProps<'Chartjs'> {}

function IOChartjs(props: ChartjsProps, ref: React.Ref<HTMLDivElement>) {
  return (
    <Suspense fallback={<div>Loading ChartjsLazy...</div>}>
      <ChartjsLazy {...props} ref={ref} />
    </Suspense>
  );
}

export default React.forwardRef(IOChartjs);
